(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-slideshow-v1"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var slider = document.querySelector('.slick-side-h1');
  if (!slider) return;

  $('.slick-side-h1').slick({
    dots: true,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,              // 🔥 enables auto slideshow
    autoplaySpeed: 4000,         // ⏱ time between slides (5 sec)
    pauseOnHover: false,         // keeps sliding even when hovered
    pauseOnFocus: false,
    adaptiveHeight: false,
    fade: true,                 // change to true if you want fade transition
    cssEase: 'ease-in-out'
  });
});

  } catch(e) { console.error(e); }
})();
})();
